import request from '@/utils/http';
/**
 * 函数节流
 * @param fn
 * @param interval
 * @returns {Function}
 * @constructor
 */
export const Throttle = (fn, t) => {
    let last;
    let timer;
    const interval = t || 500;
    return function () {
        const args = arguments;
        const now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                last = now;
                fn.apply(this, args);
            }, interval);
        } else {
            last = now;
            fn.apply(this, args);
        }
    };
};

/*
@desc：找出数组中的最大值
@param arr 原始数组
@return max 数组中的最大值
*/
export const arrmax = (arr) => {
    let max = arr[0];
    for (let i = 0; i < arr.length; i++) {
        if (max < arr[i]) {
            max = arr[i];
        }
    }
    return max;
};

// 分页查询企业前缀
export const getEnterprise = (params) => {
    return request({
        url: '/api-sn/enterprise/searchPage',
        method: 'post',
        data: params
    });
};

// 解析报表
export const getAnalysisReport = (params) => {
    return request({
        url: '/api-sn/identityDailyStatistics/analyzeReport',
        method: 'post',
        data: params
    });
};

// 查询企业解析量标识数量
export const getAnalysisIdentifyingNumber = (params) => {
    return request({
        url: '/api-sn/identityDailyStatistics/enterpriseReport',
        method: 'post',
        data: params
    });
};

// 查询企业标识
export const getCorporateIdentify = (params) => {
    return request({
        url: '/api-sn/identityDailyStatistics/rankingReport',
        method: 'post',
        data: params
    });
};